module.exports = __webpack_public_path__ + "assets/images/652c8e531305aca1455a47382b7ce384.svg";